import { Box, Button, Stack, Typography } from "@mui/material";
import ProfileAndCommentComponent from "./ProfileAndCommentComponent";
import PostCommentAndLikesShareComponent from "./PostCommentAndLikesShareComponent";

function ThirdSectionAppHome() {
  return (
    <Stack
      direction="column"
      id="create-post"
      sx={{
        bgcolor: "#ffffff",
        borderRadius: "24px",
        px: "20px",
        py: "16px",
      }}
    >
      <ProfileAndCommentComponent
        avatarSrc="/images/smith.jpeg"
        primaryText="Annette Black"
        secondaryText="5 days ago"
        profile={true}
        bluetick={true}
        menuOrImojiButton={{ src: "/icons/3dotsmenu.svg" }}
        postDescription={true}
      >
        <Typography variant="body2">
          Which drink do you think is the better summer drink, and why?
          #quickquestion #rapidfirequestion
        </Typography>
      </ProfileAndCommentComponent>
      <Stack
        spacing={1}
        sx={{
          border: "1px solid #E2E8F0",
          py: "12px",
          px: "14px",
          borderRadius: "16px",
          my: "14px",
        }}
      >
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Typography
            variant="body2"
            sx={{
              bgcolor: "#B8EBFF",
              color: "#1E293B",
              borderRadius: "8px",
              p: "10px",
              py: "8px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              pr: "200px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>55%</span> Lemonade{" "}
            <Box component="img" src="/icons/blueTickCircleIcon.svg"></Box>
          </Typography>
          <Typography variant="body2" sx={{ color: "#94A3B8" }}>
            1,418
          </Typography>
        </Stack>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Typography
            variant="body2"
            sx={{
              bgcolor: "#F1F5F9",
              color: "#475569",
              borderRadius: "8px",
              p: "10px",
              py: "8px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              pr: "100px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>25%</span> Energy Drink{" "}
          </Typography>
          <Typography variant="body2" sx={{ color: "#94A3B8" }}>
            4,587
          </Typography>
        </Stack>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Typography
            variant="body2"
            sx={{
              bgcolor: "#F1F5F9",
              color: "#475569",
              borderRadius: "8px",
              p: "10px",
              py: "8px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>12%</span>Milkshake{" "}
          </Typography>
          <Typography variant="body2" sx={{ color: "#94A3B8" }}>
            1,418
          </Typography>
        </Stack>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Typography
            variant="body2"
            sx={{
              bgcolor: "#F1F5F9",
              color: "#475569",
              borderRadius: "8px",
              p: "10px",
              py: "8px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>8%</span>Tea{" "}
          </Typography>
          <Typography variant="body2" sx={{ color: "#94A3B8" }}>
            487
          </Typography>
        </Stack>
        <Typography variant="body2" sx={{ color: "#94A3B8" }}>
          Jun 25, 2029 — 12,157 votes total
        </Typography>
      </Stack>
      <PostCommentAndLikesShareComponent />
      <ProfileAndCommentComponent
        avatarSrc="/images/Annette-Black.jpeg"
        primaryText="Annette Black"
        secondaryText="5 days ago"
        menuOrImojiButton={{ src: "/icons/heart-emoji.svg", text: "02" }}
        commentDescription={true}
      >
        <Typography variant="body2">
          Hi my name is Sharon Mosby, I’m a Arkansas inventor looking for advice
          from a investor. I have a patent number on a idea that I came up with.
          Thanks!
        </Typography>
      </ProfileAndCommentComponent>
      <Button
        variant="text"
        sx={{
          alignSelf: "start",
          width: "auto",
          minWidth: "0",

          color: "#9C9C9C",
          "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
          "&:active": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
          "&:focus": {
            outline: "none",
          },
          textTransform: "none",
          p: "0px",
          pt: "30px",
        }}
      >
        Show 5 more Comments ...
      </Button>
    </Stack>
  );
}

export default ThirdSectionAppHome;
